import { StyleSheet } from 'aphrodite';
import { THEME } from '@HoudiniUI/Theme/theme';

const inputFieldWidth = 300;
// Aligns the section under the Profile card's value column (matches the 200px `formFieldLabel` width).
const labelColumnWidth = 200;

export const styleSheet = StyleSheet.create({
	container: {
		marginBottom: THEME.spacing.md,
		marginLeft: labelColumnWidth,
	},
	enableRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	enableLabel: {
		color: THEME.colors.text.main,
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.sm,
	},
	fields: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.md,
	},
	field: {
		width: inputFieldWidth,
	},
	inputControl: {
		width: '100%',
	},
	fieldLabel: {
		color: THEME.colors.text.light,
		display: 'block',
		fontSize: THEME.typography.fontSizes.xs,
		marginBottom: THEME.spacing.xs,
	},
	validationError: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
	actions: {
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.sm,
	},
	actionButton: {
		whiteSpace: 'nowrap',
	},
	reconnectBanner: {
		alignItems: 'center',
		background: THEME.colors.warning.light,
		border: `1px solid ${THEME.colors.warning.main}`,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.md,
		padding: THEME.spacing.sm,
	},
	reconnectText: {
		color: THEME.colors.text.main,
		flex: 1,
		fontSize: THEME.typography.fontSizes.sm,
		minWidth: 180,
	},
	gmailHint: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
	disclaimer: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		lineHeight: 1.4,
		maxWidth: 420,
	},
	verifyStatus: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.xs,
		marginTop: THEME.spacing.sm,
		maxWidth: 420,
	},
	verifyValidating: {
		color: THEME.colors.text.light,
	},
	verifySuccess: {
		color: THEME.colors.success.main,
	},
	verifyError: {
		color: THEME.colors.danger.main,
	},
});
